import { resolveSafeToPath } from "@/lib/auth/destination";
import { useRouteLanguage } from "@/lib/locale/navigation";
import { localizeHref } from "@/lib/locale/paths";

export { resolveSafeToPath } from "@/lib/auth/destination";

export const useToPath = (defaultPath = "/app/dashboard/") => {
  const locale = useRouteLanguage();
  const origin = typeof window === "undefined" ? "https://teksta.invalid" : window.location.origin;
  const toPathParam =
    typeof window === "undefined"
      ? null
      : new URLSearchParams(window.location.search).get("toPath");
  const relativePath = resolveSafeToPath({ defaultPath, toPathParam });
  return new URL(localizeHref(relativePath, locale), origin);
};
